import { Resource } from 'angular4-hal';

export class Line extends Resource {
    index: string;
    name: string;
}
